export const MODES = {
  search: "SEARCH",
  new_group: "NEW_GROUP",
  add_members: "ADD_MEMBERS",
};
